import React from 'react';
import { CContainer, CButton } from '@coreui/react';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import CustomerTable from '../../components/CustomerTable/CustomerTable';
import './Customer.scss';

const Customer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateCustomer = () => {
    navigate('/customers/create');
  };

  return (
    <div className="customer-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('customers')}</div>
        <CustomerTable />
      </CContainer>
      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateCustomer}
        title={t('createCustomer')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

export default Customer; 